<template>
  <div
    v-if="total > pageSize"
    class="mt-3 flex flex-col gap-2 border-t border-slate-100 pt-3 sm:flex-row sm:items-center sm:justify-between"
  >
    <p class="text-xs font-semibold text-slate-500">
      Hiển thị {{ startItem }}-{{ endItem }} / {{ total }}
    </p>
    <div class="flex items-center gap-2">
      <UiButton
        variant="secondary"
        size="sm"
        icon="prev"
        :disabled="modelValue <= 1"
        @click="emitPage(modelValue - 1)"
      >
        Trước
      </UiButton>
      <span
        class="inline-flex h-8 min-w-16 items-center justify-center rounded-lg bg-slate-50 px-3 text-xs font-bold text-slate-700"
      >
        {{ modelValue }} / {{ pageCount }}
      </span>
      <UiButton
        variant="secondary"
        size="sm"
        icon="next"
        :disabled="modelValue >= pageCount"
        @click="emitPage(modelValue + 1)"
      >
        Sau
      </UiButton>
    </div>
  </div>
</template>

<script lang="ts">
import { computed } from "vue";

export default {
  props: {
    modelValue: { type: Number, default: 1 },
    total: { type: Number, default: 0 },
    pageSize: { type: Number, default: 10 },
  },
  emits: ["update:modelValue"],
  setup(props: any, { emit }: any) {
    const pageCount = computed(() =>
      Math.max(1, Math.ceil(props.total / props.pageSize)),
    );
    const startItem = computed(() =>
      props.total ? (props.modelValue - 1) * props.pageSize + 1 : 0,
    );
    const endItem = computed(() =>
      Math.min(props.total, props.modelValue * props.pageSize),
    );
    const emitPage = (page: number) => {
      emit("update:modelValue", Math.min(Math.max(1, page), pageCount.value));
    };
    return { pageCount, startItem, endItem, emitPage };
  },
};
</script>
